const useTruncateText = (
  text: string,
  maxLength: number,
  isTooLong: boolean,
) => {
  return isTooLong ? `${text.slice(0, maxLength)}...` : text;
};

export default useTruncateText;
